import { render, staticRenderFns } from "./DisplayConfiguration.vue?vue&type=template&id=4cf46c12&scoped=true"
import script from "./DisplayConfiguration.vue?vue&type=script&lang=js"
export * from "./DisplayConfiguration.vue?vue&type=script&lang=js"
import style0 from "./DisplayConfiguration.vue?vue&type=style&index=0&id=4cf46c12&prod&scoped=true&lang=css"
import style1 from "./DisplayConfiguration.vue?vue&type=style&index=1&id=4cf46c12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf46c12",
  null
  
)

export default component.exports